var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"decorator-btn-measurements",class:{
    'decorator-btn-measurements--selected': this.isSelected,
    'decorator-btn-measurements--disabled': this.isDisabled,
  },style:({
    borderBottomColor: this.isSelected && this.selectedColor ? _vm.selectedColor : null,
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }